import { createSlice } from "@reduxjs/toolkit";

import { getBlogCategoryApi } from "../../reduxApi/admin/BlogCategoryReducApi";
import {
  getBlogCountApi,
  getBlogListApi,
  getBlogWithRowidApi,
} from "../../reduxApi/admin/BlogListReduxApi";
import { getBrandListApi } from "../../reduxApi/admin/BrandReduxApi";

const BlogListSlice = createSlice({
  name: "PurchaseOders",
  initialState: {
    status: "idle",
    getBlogList: [],
    blogsDetails: [],
    BlogCount: 0,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBlogListApi.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getBlogListApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.getBlogList = action.payload.data;
        console.log("state.getBlogList", state.getBlogList);
      })
      .addCase(getBlogWithRowidApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.blogsDetails = action.payload.data.blogs;
        console.log("state.blogsDetails", state.blogsDetails);
      })
      .addCase(getBlogCountApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.BlogCount = action.payload.data.count;
        console.log("state.BlogCount", state.BlogCount);
      });
  },
});

export default BlogListSlice.reducer;
